import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		dark: false,
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#2f85c6', // brand blue
				secondary: '#9384bd', // brand violet
				accent: '#ffd61d', // brand orange
				error: '#D83620', // logo red
				info: '#007DC5', // logo blue
				success: '#41AD49', // logo green
				warning: '#FCAF17', // logo orange
				//
				black: '#000',
			},
			dark: {
				primary: '#d81b60',
				secondary: '#00B0FF',
				accent: '#82B1FF',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
				//
				black: '#000',
			},
		},
	},
	icons: {
		iconfont: 'mdi',
	},
})
